"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRenderProps = exports.cleanInitialMessage = void 0;
var _types = require("./types");
var updateRenderProps = exports.updateRenderProps = function updateRenderProps(_ref) {
  var user = _ref.user,
    token = _ref.token,
    _ref$listId = _ref.listId,
    listId = _ref$listId === void 0 ? null : _ref$listId,
    _ref$roomname = _ref.roomname,
    roomname = _ref$roomname === void 0 ? null : _ref$roomname,
    _ref$roomName = _ref.roomName,
    roomName = _ref$roomName === void 0 ? null : _ref$roomName,
    _ref$initialMessage = _ref.initialMessage,
    initialMessage = _ref$initialMessage === void 0 ? undefined : _ref$initialMessage,
    _ref$sendInitialMessa = _ref.sendInitialMessageDirectly,
    sendInitialMessageDirectly = _ref$sendInitialMessa === void 0 ? false : _ref$sendInitialMessa,
    imageUrlFormat = _ref.imageUrlFormat,
    loginUrl = _ref.loginUrl;
  var room = roomname || roomName;
  return {
    type: _types.UPDATE_RENDER_PROPS,
    value: {
      user: user,
      token: token,
      listId: listId,
      roomname: room,
      initialMessage: initialMessage,
      sendInitialMessageDirectly: sendInitialMessageDirectly,
      imageUrlFormat: imageUrlFormat,
      loginUrl: loginUrl
    }
  };
};
var cleanInitialMessage = exports.cleanInitialMessage = function cleanInitialMessage() {
  return {
    type: _types.UPDATE_RENDER_PROPS,
    value: {
      initialMessage: undefined,
      sendInitialMessageDirectly: false
    }
  };
};